import { motion, AnimatePresence } from "framer-motion";

export default function Loader({ silent = false }) {
  return (
    <AnimatePresence>
      <motion.div
        key="loader"
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="fixed inset-0 z-[9999] bg-cream-100 flex items-center justify-center"
        data-testid="page-loader"
      >
        <div className="absolute inset-0 bg-spotlight-gold opacity-80 pointer-events-none" />
        {!silent && (
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col items-center gap-6 px-8 text-center"
          >
            <motion.div
              animate={{ opacity: [0.65, 1, 0.65] }}
              transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
              className="p-4 rounded-xl bg-ink-900 shadow-[0_0_40px_rgba(212,175,55,0.25)]"
            >
              <img
                src="/assets/logo/logo-white.png"
                alt="Captured Moments — Luxury Photo Booth"
                className="w-40 md:w-52 h-auto"
              />
            </motion.div>
            <div className="overline">Captured Moments</div>
            <div className="h-px w-44 luxe-divider" />
            <div className="text-xs uppercase tracking-[0.32em] text-ink-700/70">Loading the experience</div>
          </motion.div>
        )}
      </motion.div>
    </AnimatePresence>
  );
}
